<template>
  <v-container fill-height>
    <v-dialog v-model="debugInput" persistent :max-width="500">
      <v-card tile>
        <v-card-title>Manual Route Entry</v-card-title>
        <v-card-text class="pt-3 pb-0">
          <v-text-field outlined textarea v-model="debugInputAnswer"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="debugInput = false">Cancel</v-btn>
          <v-btn color="primary" :disabled="debugInputAnswer === null" @click="handleQuestionDebugConfirm">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="linkToQMDialog" persistent max-width="500">
      <v-card>
        <v-card-title>Link to QuestionMark</v-card-title>
        <v-card-text class="pt-2">
          <v-alert type="info" outlined dense :value="linkToQM != ''">
            <span class="caption">Editing this link could cause issues with unscored assessments!</span>
          </v-alert>
          <v-text-field dense outlined hide-details
                        mask="###########"
                        name="input-1"
                        label="QuestionMark QID"
                        id="qmLinkInput"
                        v-model="linkToQM"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed outlined color="primary" @click.stop="linkToQMDialog=false">Cancel</v-btn>
          <v-btn depressed color="primary" @click.stop="handleQMLink">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent max-width="500">
      <v-card tile>
        <v-card-title>Delete Question</v-card-title>
        <v-card-text class="pt-3">
          Are you sure you want to delete this question? This cannot be undone and may affect existing
          unscored assessments that relate to this question.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click.stop="deleteDialog=false">Cancel</v-btn>
          <v-btn color="error" depressed @click.stop="handleDeleteConfirm">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="space-around">
      <v-col xs="12" md="10" lg="8">
        <v-sheet class="outlinedsheet" style="width: 100%">
          <v-card-title class="py-0">{{getNewQuestion.qid}}: {{getNewQuestion.description}}</v-card-title>
          <v-card-title class="py-0">QuestionMark ID: {{getNewQuestion.linked_id}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col class="pa-1">
                <v-btn depressed class="primary" @click="handleSelectEdit" :to="{name: 'startPoint'}" block>
                  Edit Question
                  <v-icon right dark>mdi-edit</v-icon>
                </v-btn>
              </v-col>
              <v-col class="pa-1">
                <v-btn depressed @click="linkToQMDialog = true" class="primary" block>
                  Link to QuestionMark
                  <v-icon right dark>mdi-link</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pa-1">
                <v-btn depressed @click="handleDeleteQuestion" class="error" block>
                  Delete Question
                  <v-icon right dark>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col class="pa-1">
                <v-btn depressed @click="handleQuestionDebug" class="warning text--primary" light block>
                  Manual Marking
                  <v-icon right dark>mdi-bug</v-icon>
                </v-btn>
              </v-col>
              <v-col class="pa-1">
                <v-btn depressed @click="handleTryOut" class="info" block>
                  Try it out
                  <v-icon right dark>mdi-play</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="pt-2">
              <question-iframe></question-iframe>
            </v-row>
          </v-card-text>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import QuestionIframe from "../components/MainContent/QuestionDetails/QuestionIframe";

  export default {
    components: {QuestionIframe},
    name: 'Details',
    computed: {
      ...mapGetters(['getNewQuestion', 'GET_API_KEY']),
      linkToQM: {
        get() {
          return this.getNewQuestion.linked_id;
        },
        set(val) {
          this.updatedLinkToQM = val % 100000000;
        }
      }
    },

    data() {
      return {
        debugInput: false,
        debugInputAnswer: null,
        linkToQMDialog: false,
        deleteDialog: false,
        linkAlert: false,
        updatedLinkToQM: ''
      }
    },

    methods: {
      ...mapActions(['UPDATE_QUESTIONMARK_ID', 'DELETE_QUESTION', 'MARK_FETCH_ANSWER_DATA']),
      ...mapMutations(['SET_TASK']),
      handleTryOut() {
        let start = JSON.parse(this.getNewQuestion.startpoint);
        let end = JSON.parse(this.getNewQuestion.endpoint);
        var url = process.env.VUE_APP_BASE_URL + "/assess?user=" + this.GET_API_KEY + "&start=" + start.geometry.coordinates.toString() + "&end=" + end.geometry.coordinates.toString() + "&tryitout=true" + "&linked_id=" + 'geoxphere_' + encodeURIComponent(this.getNewQuestion.linked_id);
        window.open(url, '_blank');
      },
      handleSelectEdit() {
        this.SET_TASK('edit');
      },
      handleQMLink() {
        if (this.updatedLinkToQM === '') {
          this.linkToQMDialog = false
          return;
        }
        this.UPDATE_QUESTIONMARK_ID(this.updatedLinkToQM);
        this.linkToQMDialog = false
        this.updatedLinkToQM = '';
      },
      handleDeleteQuestion() {
        this.deleteDialog = true;
      },
      handleQuestionDebug() {
        this.debugInput = true;
      },
      handleQuestionDebugConfirm() {

        let newAnswer = this.debugInputAnswer.replace(/\\/g, '');
        newAnswer = newAnswer.replace(/\s/g, '');

        this.$store.commit('SET_ANSWER_DATA', {
          assessor: this.getNewQuestion,
          candidate: newAnswer
        });
        this.$router.push({
          name: 'AnswerMap'
        });
      },
      handleDeleteConfirm() {
        this.deleteDialog = false;
        this.DELETE_QUESTION().then(() => {
          this.$router.push({
            name: 'home'
          });
        });
      }
    }
  }
</script>

<style>
  .outlinedsheet {
    border: 1px solid #ccc !important;
    border-radius: 5px !important;
  }
</style>
